import React from 'react';
import PropTypes from 'prop-types';
import uuid from 'uuid/v4';
import { Link } from 'react-router-dom';
import { map } from 'lodash';

const ListItem = ({ fields, data }) => {
  if (!data) return null;

  const renderDataCell = field => {
    const cellType = data[field.key];

    switch (cellType.type) {
      case 'image':
        return (
          <td key={uuid()} className="tvt-cell--no-padding">
            <img
              className="tvt-report-list__cell--image"
              src={data[field.key].url}
              alt="TVLytics Show"
            />
          </td>
        );
      case 'link':
        return (
          <td key={uuid()}>
            <Link
              to={data[field.key].url}
              className="tvt-report-list__cell--link"
            >
              {data[field.key].label}
            </Link>
          </td>
        );
      case 'string':
        return (
          <td key={uuid()}>
            <span className="tvt-report-list__cell--text">
              {data[field.key].value}
            </span>
          </td>
        );
      default:
        return null;
    }
  };

  return (
    <tr className="tvt-report-list__row">
      {map(fields, f => renderDataCell(f, data))}
    </tr>
  );
};

ListItem.propTypes = {
  data: PropTypes.shape({}).isRequired,
  fields: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      label: PropTypes.string
    })
  ).isRequired
};

export default ListItem;
